import React from "react";
import { Table } from "../../../../v2/design-system";
import { formatDateTime } from "../../../../utils/common";
import { HubViewRowButton } from "../tableShared";

const TransactionTable = ({ data, loading = false, pagination, onTransactionView }) => {
  const columns = [
    {
      key: "createdAt",
      label: "Settlement Date",
      align: "left",
      render: (_, row) => formatDateTime(row?.createdAt),
    },
    {
      key: "settlementAmount",
      label: "Amount",
      render: (_, row) =>
        row?.settlementAmount !== undefined && row?.settlementAmount !== null ? `₹${row.settlementAmount}` : "",
    },
    { key: "txnStatus", label: "Status", align: "left" },
    { key: "route", label: "Route", align: "left" },
    { key: "accountNo", label: "Settled To Account", align: "left" },
    { key: "voucherId", label: "Transaction Id", align: "left" },
    {
      key: "actions",
      label: "Actions",
      render: (_, row) => (
        <HubViewRowButton
          ariaLabel={`View details for ${row.transactionId ?? "transaction"}`}
          onClick={() => onTransactionView(row)}
        />
      ),
    },
  ];

  return (
    <Table
      data={data}
      columns={columns}
      rowKey="transactionId"
      loading={loading}
      emptyMessage="No settlement transactions"
      pagination={pagination}
    />
  );
};

export default TransactionTable;
